const DB_NAME = "plansarthi-offline";
const DB_VERSION = 1;
const QUEUE = "queue";
const CACHE = "cache";

let dbPromise = null;

function openDb() {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(QUEUE)) db.createObjectStore(QUEUE, { keyPath: "client_id" });
      if (!db.objectStoreNames.contains(CACHE)) db.createObjectStore(CACHE, { keyPath: "key" });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbPromise;
}

function tx(store, mode, run) {
  return openDb().then(
    (db) =>
      new Promise((resolve, reject) => {
        const t = db.transaction(store, mode);
        const req = run(t.objectStore(store));
        t.onerror = () => reject(t.error);
        if (req) req.onsuccess = () => resolve(req.result);
        else t.oncomplete = () => resolve(true);
      })
  );
}

export const newClientId = () =>
  `off_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;

export const queueAdd = (entry) => tx(QUEUE, "readwrite", (s) => s.put(entry));
export const queueAll = () => tx(QUEUE, "readonly", (s) => s.getAll());
export const queueRemove = (clientId) => tx(QUEUE, "readwrite", (s) => s.delete(clientId));
export const queueCount = () => tx(QUEUE, "readonly", (s) => s.count());

export const cacheSet = (key, value) =>
  tx(CACHE, "readwrite", (s) => s.put({ key, value, at: Date.now() }));
export const cacheGet = (key) => tx(CACHE, "readonly", (s) => s.get(key)).then((r) => (r ? r.value : null));
